import { defineStore } from 'pinia'
import { ref } from 'vue'

export interface QuizAccessLearner {
  firstName: string
  lastName: string
  hasEmail: boolean
}

export interface QuizAccessCourse {
  name: string
  publicId: string
}

export interface QuizAccessTenant {
  name: string
  privacyPolicyUrl?: string
}

export interface QuizAccessMatch {
  company: string
  course: string
  courseStartDate: string | null
  matchToken: string
  privacyPolicyUrl?: string
}

export const useQuizAccessStore = defineStore('quizAccess', () => {
  const token = ref<string | null>(null)
  const learner = ref<QuizAccessLearner | null>(null)
  const course = ref<QuizAccessCourse | null>(null)
  const tenant = ref<QuizAccessTenant | null>(null)
  const emailCaptured = ref(false)
  const pendingMatches = ref<QuizAccessMatch[]>([])

  function setSession(data: {
    token: string
    learner: QuizAccessLearner
    course: QuizAccessCourse
    tenant: QuizAccessTenant
  }) {
    token.value = data.token
    learner.value = data.learner
    course.value = data.course
    tenant.value = data.tenant
  }

  function setPendingMatches(matches: QuizAccessMatch[]) {
    pendingMatches.value = matches
  }

  function markEmailCaptured() {
    emailCaptured.value = true
  }

  function clearCourse() {
    token.value = null
    course.value = null
  }

  function clear() {
    token.value = null
    learner.value = null
    course.value = null
    tenant.value = null
    emailCaptured.value = false
    pendingMatches.value = []
  }

  return {
    token,
    learner,
    course,
    tenant,
    emailCaptured,
    pendingMatches,
    setSession,
    setPendingMatches,
    markEmailCaptured,
    clearCourse,
    clear,
  }
})
// NOT persisted — session dies on tab close (by design)
